import type {
  SuggestionOverrideRevertBodyType,
  SuggestionOverridesBodyType,
} from "@shared/schemas/connections.schemas";
import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

export function createConnectionsApi(apiClient: AxiosInstance) {
  function overridesUrl(eventIdPublic: EventIdPublic): string {
    return `${connectionsUrl(eventIdPublic)}/overrides`;
  }

  function connectionsUrl(eventIdPublic: EventIdPublic): string {
    return `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/connections`;
  }

  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getConnectionsView(
    eventIdPublic: EventIdPublic,
  ): Promise<unknown> {
    const response = await apiClient.get(connectionsUrl(eventIdPublic));
    return response.data;
  }

  async function saveConnectionOverrides(
    eventIdPublic: EventIdPublic,
    body: SuggestionOverridesBodyType,
  ): Promise<void> {
    await apiClient.post(overridesUrl(eventIdPublic), body);
  }

  async function revertConnectionOverrides(
    eventIdPublic: EventIdPublic,
    body: SuggestionOverrideRevertBodyType,
  ): Promise<void> {
    await apiClient.put(`${overridesUrl(eventIdPublic)}/revert`, body);
  }

  return {
    getConnectionsView,
    saveConnectionOverrides,
    revertConnectionOverrides,
  } as const;
}
